import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    fontFamily: 'Nunito !important',

    '& .MuiTablePagination-selectLabel': {
      opacity: 0.6,
    },

    '& .MuiTablePagination-actions': {
      opacity: 0.6,
    },
  },

  tableContainer: {
    height: '100%',
  },
}))

export { useStyles }
